/**
 *
 * @param {string} fontName
 * @param {string} fontNameBold
 * @param {boolean} bold
 * @return {string}
 */
export function getTypoName({ fontName, fontNameBold }, bold = false) {
  return bold ? fontNameBold : fontName;
}
